




import {
  Component,
  OnInit,
  ViewChild,
  ElementRef,
  NgZone,
} from "@angular/core";
import { LoaderService } from "../services/loader.service";
import { AddToCartService } from "../services/add-to-cart.service";
import { NgbModal, ModalDismissReasons } from "@ng-bootstrap/ng-bootstrap";
import { CommonHttpService } from "../../components/commonHttp.service";
import { Router, ActivatedRoute } from "@angular/router";
import { environment } from "../../../environments/environment";
import { Location } from "@angular/common";
import "rxjs/add/operator/map";
import "rxjs/add/operator/first";
import { } from "jquery";

declare var $;

@Component({
  selector: "app-header",
  templateUrl: "./header.component.html",
  styleUrls: ["./header.component.css"],
})
export class HeaderComponent implements OnInit {
  @ViewChild("#account-dd") selectRef: ElementRef;
  searchProduct:boolean = true;
  isavailable = false;
  utm_source: string;
  closeResult: string;
  baseUrl: any = environment.apiUrl;
  imageUrl: any = environment.imageUrl;
  searchbox: string;
  searchresult: any = [];
  searchResCat: string;
  searchResPro: string;
  arrowkeyLocation = 0;
  category: any = [];
  cart: any = {};
  cartItems: any = [];
  referralUrl: any = environment.referralUrl;
  isLoggedIn: boolean;
  customerName: any;
  referralEmail: any;
  isCartOpen = false;
  EcartGrandTotal: number = 0;
  EcartTotal: number = 0;
  EcartTotalTaxAmount: number = 0;
  EcartTotalCessAmount: number = 0;
  EcartTotalDiscount: number = 0;
  quantityError: boolean = false;
  availableQuantity: number;
  outOfStockError: boolean = false;
  userId: number;
  menuItems: any = [];
  productArray:any=[];
  constructor(
    private service: CommonHttpService,
    private modalService: NgbModal,
    private addToCartService: AddToCartService,
    private router: Router,
    private route: ActivatedRoute,

    private loaderService: LoaderService,
    private ngZone: NgZone
  ) {


    this.route.queryParams
      .filter((params) => params.utm_source)
      .subscribe((params) => {

        this.utm_source = params.utm_source;
        console.log(this.utm_source); // popular
        if (this.utm_source == "phonepe") {
          localStorage.setItem("utm_sources", JSON.stringify(this.utm_source));
          console.log(JSON.parse(localStorage.getItem("utm_sources")));

          window.scrollTo(0, 0);
        }
      });
    this.addToCartService.isCartChanged.subscribe((flag) => {
      this.checkLoginStatus();
      this.cart = JSON.parse(localStorage.getItem("cart"));
      this.cartItems = this.cart != null ? this.cart.EcartItem : [];
      console.log(this.cartItems);
      if (this.cart != null) {
        this.checkOutOfStockItems();
        this.CalculateTotals();
      }
    });
  }
  onWhatsApp() {
    // window.location.href = "https://api.whatsapp.com/send?phone=917327859113"
    window.open(
      'https://api.whatsapp.com/send?phone=917327859113',
      '_blank' // <- This is what makes it open in a new window.
    );

  }
  ngOnInit() {

    setTimeout(() => {
      let IsPhonepe = JSON.parse(localStorage.getItem("utm_sources"));
      if (IsPhonepe == "phonepe") {
        this.isavailable = true;

      }
    }, 2000);


    (function ($) {
      "use strict"

      var responsiveNav = $('#responsive-nav'),
        catToggle = $('#responsive-nav .category-nav .category-header'),
        catList = $('#responsive-nav .category-nav .category-list'),
        menuToggle = $('#responsive-nav .menu-nav .menu-header'),
        menuList = $('#responsive-nav .menu-nav .menu-list');


      $(document).ready(function () {
        $('.category-nav').mouseover(function () {
          $('.category-list').addClass('open');
        });

        $('.category-nav').mouseout(function () {
          $('.category-list').removeClass('open');
        });

      });

      $(document).click(function (event) {
        if (!$(event.target).closest(responsiveNav).length) {
          if (responsiveNav.hasClass('open')) {
            responsiveNav.removeClass('open');
            $('#navigation').removeClass('shadow');
          } else {
            if ($(event.target).closest('.nav-toggle > button').length) {
              if (!menuList.hasClass('open') && !catList.hasClass('open')) {
                menuList.addClass('open');
              }
              $('#navigation').addClass('shadow');
              responsiveNav.addClass('open');
            }
          }
        }
      });



      $('.side-dropdown').mouseover(function () {
        $(this).addClass('open');
      });

      $('.side-dropdown').mouseout(function () {
        $(this).removeClass('open');
      });

      $(document).ready(function () {

        function checkPosition() {
          if (window.matchMedia('(max-width: 1024px)').matches) {
            $('.fa-list').click(function () {
              $('.category-list').toggleClass('open');
              $('.side-dropdown').toggleClass('open');
            });
          } else {
            //...
          }
        }
        checkPosition();
      });




    })(jQuery);




    console.log(this.utm_source);
    this.checkLoginStatus();
    this.cart = JSON.parse(localStorage.getItem("cart"));
    this.userId = Number(localStorage.getItem("customerId"));
    this.cartItems = this.cart != null ? this.cart.EcartItem : [];
    if (this.cart != null) {
      this.checkOutOfStockItems();
      this.CalculateTotals();
    }
    this.service.get(this.baseUrl + "CategoryAPI/GetAllMenuCategory").subscribe(
      (data) => {
        this.category = data;
        this.menuItems = this.category;
        console.log(data);
      },
      (error) => { }
    );
  
  }
  

  // class="fa fa-close fa-2x"
  hello() {
    this.category = this.menuItems;
    var catList = $("#responsive-nav .category-nav .category-list");
    // menuList.removeClass('open');
    catList.toggleClass("open");
  }
  closemenu() {
    this.category = [];
  }

  checkLoginStatus() {
    if (localStorage.getItem("isLoggedin")) {
      this.isLoggedIn = true;
    //  this.customerName = localStorage.getItem("customerName").split(" ")[0];
      this.ngZone.onMicrotaskEmpty.first().subscribe(() => {
        $(document).ready(function () {
          //  console.log("abcd");
          $(".account").click(function () {
            $(".account-dd").addClass("active");
          });
          $(".account-close").click(function () {
            $(".account-dd").removeClass("active");
          });
          $(".account-link").click(function () {
            $(".account-dd").removeClass("active");
          });
        });
      });
    } else {
      this.isLoggedIn = false;
    }
  }
  togglemenu = function (event) {
    var yourUl = document.getElementById("mMenu");
    yourUl.style.display = yourUl.style.display === "none" ? "" : "none";
  };
  addclassf = function (classname) {
    alert(classname);
  };
  hideresult = function () {
  //  this.searchresult = [];
    this.searchProduct = true;
  };
  showSearchResults = function () {
    console.log("called");
    if (this.searchbox != undefined) {
      if (this.searchbox.length >= 3) {
        console.log("called");
        this.router.navigate(["./ProductAll/" + this.searchbox]);

        // this.service.get(this.baseUrl + 'ProductAPI/GetTotalProductsTypeKeyword' + this.searchbox)
        //   .subscribe(
        //     data => {

        //       this.searchresult = data
        //       console.log(this.searchresult)
        //     },
        //     (error) => {
        //     })
      } else if (this.searchbox.length < 3) {
      //  this.searchresult = [];
        this.arrowkeyLocation = 0;
      }
    }
  };

  goToProductCat = function (id, type, val) {
    this.searchbox = "";
    console.log(type);
    if (type == "Category") {
      window.location.href = "category/" + id;
      // this.router.navigate(['/category', id]);
    } else if (type == "Product") {
      window.location.href = "product/" + id;
    }
    console.log(id);
  };

  changeStyle = function (i) {
    this.arrowkeyLocation = i;
  };

  keyDown(event: KeyboardEvent) {
    // var activeElemnts = document.getElementsByClassName("active");
    switch (event.keyCode) {
      case 38: // this is the ascii of arrow up
        if (this.arrowkeyLocation != 0) {
          this.arrowkeyLocation--;
        }
        break;
      case 40: // this is the ascii of arrow down
        this.arrowkeyLocation++;
        break;
      case 13:

      // if (activeElemnts.length > 0) {

      // this.goToProductCat(activeElemnts[0].attributes["activeId"].nodeValue, activeElemnts[0].attributes["activeType"].nodeValue, activeElemnts[0].textContent);

      //}
    }
  }

  onEnter(event: KeyboardEvent) {
    var activeElemnts = document.getElementsByClassName("active");
    switch (event.keyCode) {
      case 13:
        if (this.searchbox.length > 0) {
          window.location.href = "ProductAll/" + this.searchbox;
        }
    }
  }

  LogOut() {
    localStorage.removeItem("cart");
    localStorage.removeItem("customerId");
    localStorage.removeItem("customerName");
    localStorage.removeItem("isLoggedin");
    this.cart = JSON.parse(localStorage.getItem("cart"));
    this.cartItems = this.cart != null ? this.cart.EcartItem : [];
    this.addToCartService.logOut();
    this.EcartGrandTotal = 0;
    this.router.navigate([""]);

    //  this.router.navigate(["login"]);
  }

  ReferralModelModal(referralContent: any) {
    this.modalService.open(referralContent).result.then(
      (result) => {
        this.closeResult = `Closed with: ${result}`;
      },
      (reason) => {
        this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
      }
    );
  }

  referFriend() {
    this.loaderService.display(true);
    let sendData = {
      CustomerMail: this.referralEmail,
      Subject: "Referred to use NowGrocery",
      Message:
        "Hi, <br> Signup to NowGrocery and get daily use products and groceries deliverd at home.<br> <a href='" +
        this.referralUrl +
        "signup?referralId=" +
        this.userId +
        "'>Signup to NowGrocery</a>",
    };
    this.service
      .create(this.baseUrl + "EmailAPI/EmailSend", sendData)
      .subscribe(
        (data) => {
          (<HTMLElement>document.getElementById("closeReferral")).click();
          console.log(data);
          this.loaderService.display(false);
        },
        (error) => {
          this.loaderService.display(false);
        }
      );
  }

  checkOutOfStockItems() {
    if (this.cartItems != undefined) {
      for (let i = 0; i < this.cartItems.length; i++) {
        if (this.cartItems[i].MaxStockLimit < 1) {
          this.cartItems[i].outOfStock = true;
          this.outOfStockError = true;
          this.cartItems[i].Quantity = 0;
        } else {
          this.cartItems[i].outOfStock = false;
          this.outOfStockError = false;
        }
      }
    }
  }

  CalculateTotals() {
    this.EcartTotal = 0;
    this.EcartGrandTotal = 0;
    this.EcartTotalDiscount = 0;
    this.EcartTotalTaxAmount = 0;
    this.EcartTotalCessAmount = 0;
    if (this.cartItems != undefined) {
      for (var i = 0; i < this.cartItems.length; i++) {
        this.EcartTotal =
          this.EcartTotal + this.cartItems[i].Mrp * this.cartItems[i].Quantity;
        this.EcartGrandTotal =
          this.EcartGrandTotal +
          this.cartItems[i].Price * this.cartItems[i].Quantity;
        this.EcartTotalDiscount =
          this.EcartTotalDiscount +
          (this.cartItems[i].Mrp - this.cartItems[i].Price) *
          this.cartItems[i].Quantity;
      }
      this.EcartGrandTotal = Math.round(this.EcartGrandTotal);
      this.EcartTotalTaxAmount = Math.round(this.EcartTotalTaxAmount);
      this.EcartTotalDiscount = Math.round(this.EcartTotalDiscount);
      this.cart.EcartGrandTotal = this.EcartGrandTotal;
      this.cart.EcartTotalTaxAmount = this.EcartTotalTaxAmount;
      this.cart.EcartTotalCessAmount = this.EcartTotalCessAmount;
    }
  }

  substractquantity(quantity, i) {
    this.quantityError = false;
    this.cartItems[i].Quantity = quantity - 1;
    this.cartItems[i].SubTotal = this.cartItems[i].Price * (quantity - 1);
    this.CalculateTotals();
    this.sendToCart();
  }

  addQuantity(quantity, i) {
    if (quantity + 1 > this.cartItems[i].MaxStockLimit) {
      this.quantityError = true;
      this.availableQuantity = this.cartItems[i].MaxStockLimit;
      this.cartItems[i].Quantity = quantity;
    } else {
      this.quantityError = false;
      this.cartItems[i].Quantity = quantity + 1;
    }
    this.cartItems[i].SubTotal =
      this.cartItems[i].Price * this.cartItems[i].Quantity;
    this.CalculateTotals();
    this.sendToCart();
  }
  onQuantityChange(quantity, i) {
    if (quantity > this.cartItems[i].MaxStockLimit) {
      this.quantityError = true;
      this.availableQuantity = this.cartItems[i].MaxStockLimit;
      this.cartItems[i].Quantity = this.cartItems[i].MaxStockLimit;
    } else {
      this.quantityError = false;
      this.cartItems[i].Quantity = quantity;
    }
    this.cartItems[i].SubTotal =
      this.cartItems[i].Price * this.cartItems[i].Quantity;
    this.CalculateTotals();
    this.sendToCart();
  }

  sendToCart() {
    this.cart.EcartItem = this.cartItems;
    localStorage.setItem("cart", JSON.stringify(this.cart));
    this.addToCartService.addToCartAfterCheckout();
  }

  removeFromCart(i) {
    this.quantityError = false;
    this.cartItems.splice(i, 1);
    this.cart.EcartItem = this.cartItems;
    localStorage.setItem("cart", JSON.stringify(this.cart));
    this.CalculateTotals();
    this.checkOutOfStockItems();
    this.addToCartService.removedFromCart();
    // window.location.hash = '#topElement';
  }
  close() {
    console.log("Back to Catagory Page");
    this.close();
  }
  catmenu() {
    this.category = this.menuItems;
    (function ($) {
      "use strict"

      var responsiveNav = $('#responsive-nav'),
        catToggle = $('#responsive-nav .category-nav .category-header'),
        catList = $('#responsive-nav .category-nav .category-list'),
        menuToggle = $('#responsive-nav .menu-nav .menu-header'),
        menuList = $('#responsive-nav .menu-nav .menu-list');

      catToggle.on('mouseover', function () {
        menuList.removeClass('open');
        catList.toggleClass('open');
      });

      menuToggle.on('mouseover', function () {
        catList.removeClass('open');
        menuList.toggleClass('open');
      });

      $(document).mouseover(function (event) {
        if (!$(event.target).closest(responsiveNav).length) {
          if (responsiveNav.hasClass('open')) {
            responsiveNav.removeClass('open');
            $('#navigation').removeClass('shadow');
          } else {
            if ($(event.target).closest('.nav-toggle > button').length) {
              if (!menuList.hasClass('open') && !catList.hasClass('open')) {
                menuList.addClass('open');
              }
              $('#navigation').addClass('shadow');
              responsiveNav.addClass('open');
            }
          }
        }
      });


      $('.side-dropdown').mouseover(function () {
        $(this).addClass('open');
      });

      $('.side-dropdown').mouseout(function () {
        $(this).removeClass('open');
      });
      // responsive - nav


    })(jQuery);

  }

  mobileView() {
    $(document).ready(function () {

      function checkPosition() {
        if (window.matchMedia('(max-width: 1024px)').matches) {
          $('.fa-list').click(function () {
            $('.category-list').toggleClass('open');
            $('.side-dropdown').toggleClass('open');
          });
        } else {
          //...
        }
      }
      checkPosition();
    });


  }

  viewCart() {
    console.log(this.cartItems);
    this.cart.EcartItem = this.cartItems;
    localStorage.setItem("cart", JSON.stringify(this.cart));
    if (localStorage.getItem("isLoggedin")) {
      this.addToCartService.addToCartAfterCheckout();
    }
    this.router.navigate(["cart"]);
  }

  private getDismissReason(reason: any): string {
    if (reason === ModalDismissReasons.ESC) {
      return "by pressing ESC";
    } else if (reason === ModalDismissReasons.BACKDROP_CLICK) {
      return "by clicking on a backdrop";
    } else {
      return `with: ${reason}`;
    }
  }
  showResults = function () {

    console.log(this.firstName,this.secondName,this.thirdName,this.fourthName);
    console.log(this.productArray,this.productArray.length)
    
    // if (this.searchbox != undefined) {
    //   if (this.searchbox.length >= 3) {
    //     this.service
    //       .get(
    //         this.baseUrl +
    //         "ProductAPI/GetCategoryProductByKeyWord/" +
    //         this.searchbox
    //       )
    //       .subscribe(
    //         (data) => {
    //           this.searchresult = data;
              
    //             this.searchProduct = false;
             
    //           console.log(this.searchbox)
    //           console.log(this.searchresult);
    //           console.log(this.searchProduct)
    //         },
    //         (error) => {
    //           this.searchProduct = true;
    //          }
    //       );
    //   } else if (this.searchbox.length < 3) {
    //     this.searchresult = [];
    //     this.arrowkeyLocation = -1;
    //   }
    // }


   // this.productArray=[]
    this.productArray = this.searchbox.split(" ")
    
    if(this.productArray.length >=1)
{
    if(this.productArray.length ==1)
    {
      this.firstName=this.productArray[0]
      this.secondName =''
    }
    if(this.productArray.length ==2)
    {
      this.firstName=this.productArray[0]
      this.secondName=this.productArray[1]

    }
      if(this.productArray.length == 3)
      {
        this.firstName=this.productArray[0]
      this.secondName=this.productArray[1]
        this.thirdName=this.productArray[2]
      }
      else
      {
        this.thirdName = "";
      }
      if(this.productArray.length == 4)
      {
        this.firstName=this.productArray[0]
      this.secondName=this.productArray[1]
        this.thirdName=this.productArray[2]
        this.fourthName=this.productArray[3]
      }
      else{
        this.fourthName = "";
      }
      console.log(this.productArray)
if(this.productArray.length > 0)
{
  this.service.get(
    this.baseUrl + 'ProductAPI/GetCategoryProductByKeyWord?strName1=' + this.firstName + '&strName2=' + this.secondName + '&strName3=' + this.thirdName + '&strName4=' + this.fourthName + '&SortBy'
  ).subscribe((data) => {
    this.searchresult = data;
    this.searchProduct = false;
              
  });
}
 
}

  
  

     

    
  };
  ish() {
    //  alert("hi")
    $('.side-dropdown').mouseover(function () {
      $(this).addClass('open');
    });

    $('.side-dropdown').mouseout(function () {
      $(this).removeClass('open');
    });
  }
}


// WEBPACK FOOTER //
// C:/Ajatus WorkSpace/Now Grocery/now-grocery/NowGroceryStoreFront/src/app/_shared/header/header.component.ts